// @ts-nocheck
import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { retrieveVideoPlayer } from '@cbsinteractive/avia-js';

import useInterval from 'hooks/interval';

import styles from './PlayerDebugOverlay.module.scss';

const retrieveBitrateInfo = async playerName => {
  try {
    const { bitrate, maxBitrate } = await retrieveVideoPlayer(playerName);
    return {
      bitrate: bitrate || 0,
      maxBitrate: maxBitrate || 0,
    };
  } catch {
    return {
      bitrate: 0,
      maxBitrate: 0,
    };
  }
};

const formatBitrate = bitrate => {
  const bitrateNum = Number(bitrate);
  if (bitrateNum > 999999) {
    return `${(bitrateNum / 1000000).toFixed(2)} Mbps`;
  }
  if (bitrateNum > 999) {
    return `${(bitrateNum / 1000).toFixed(2)} Kbps`;
  }
  return `${bitrateNum.toFixed(2)} Bps`;
};

const PlayerDebugOverlay = ({ playerName, className, ...rest }) => {
  const [{ bitrate, maxBitrate }, dispatch] = useReducer(
    (_, action) => {
      return action;
    },
    { bitrate: 0, maxBitrate: 0 },
  );
  useInterval(async () => {
    dispatch(await retrieveBitrateInfo(playerName));
  }, 5000);

  return (
    <div className={classNames(styles.overlay, className)} {...rest}>
      <span>Maximum Bitrate: {formatBitrate(maxBitrate)}</span>
      <span>Current Bitrate: {formatBitrate(bitrate)}</span>
    </div>
  );
};

PlayerDebugOverlay.propTypes = {
  playerName: PropTypes.string,
  className: PropTypes.string,
};

PlayerDebugOverlay.defaultProps = {
  playerName: 'CVP',
  className: null,
};

export default PlayerDebugOverlay;
